// extracted by mini-css-extract-plugin
export default {"page":"styles-module__page--i1wYK","subnav":"styles-module__subnav--RJWMW"};